// extracted by mini-css-extract-plugin
export default {"item":"styles_item__ywyYw","index":"styles_index__8Sev-","productImage":"styles_productImage__Zhbgb"};